import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {  Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ContextMenuService } from '../shared/services/context-menu.service';

@Directive({
  selector: '[customContextMenu]'
})
export class ContextMenuDirective implements OnDestroy{
  @Input() customContextMenu!: TemplateRef<any>;
  @Input() customContextData: any;
  private contextMenuElement: HTMLElement | null = null;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private viewContainer: ViewContainerRef,
    public elementRef: ElementRef<HTMLElement>,
    private contextMenuService: ContextMenuService
  ) { 

    this.contextMenuService.contextMenu$
      .pipe(takeUntil(this.destroy$))
      .subscribe((menu) => {
        this.contextMenuElement = menu;
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.hideContextMenu();
  }

  @HostListener('contextmenu', ['$event'])
  onContextMenu(event: MouseEvent): void {
    event.preventDefault();
    this.showContextMenu(event);
    console.log("bryan test", this.customContextData);
    if(this.customContextData["DocumentNo"]) {
      console.log("bryan test", this.customContextData["DocumentNo"]);
    }
  }

  @HostListener('document:scroll')
  @HostListener('document:click')
  handleHide(): void {
    this.hideContextMenu();
  }

  private showContextMenu(event: MouseEvent): void {
    // Hide any existing menu
    this.hideContextMenu(); 

    const menu = this.viewContainer.createEmbeddedView(this.customContextMenu, {
      $implicit: this.customContextData, // Pass the data object to the template
    });
    this.contextMenuElement = menu.rootNodes[0] as HTMLElement;

    // Set position of the context menu
    this.contextMenuElement.style.position = 'fixed';
    this.contextMenuElement.style.left = `${event.clientX}px`;
    this.contextMenuElement.style.top = `${event.clientY}px`;

    document.body.appendChild(this.contextMenuElement);
    this.contextMenuService.updateContextMenu(this.contextMenuElement);
  }

  public hideContextMenu(): void {
    if (this.contextMenuElement) {
      document.body.removeChild(this.contextMenuElement);
      // this.contextMenuElement = null;
      this.contextMenuService.updateContextMenu(null);
    }
  }
}
